module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "Safestore - Old Jamaica Road",
    url: process.env.ELEVENTY_ENV === 'dev' ? 'https://develop--safestore-bermondsey.netlify.app/' : 'https://www.safestorebermondsey.co.uk',

    holding: {
        "brand": "/assets/images/logo.png",
        "message": "Website coming soon"
    },

    base: {
        "contact_address": "",
        "contact_number": "020 7323 3544",
        "contact_email": "safestore@camargue.uk"
    },

    meta: {
        "defaultSocialImage": "/assets/images/social.jpg",
        "author": "",
        "description": "",
        "gtag": "GTM-NVX2RFQR",
        "gtm": "G-J7GW7LP7M4"
    },

    form: {
        "contact": {
            "catcher_id": "",
            "recaptcha": "",
            "honeypot": ""
        },
        "feedback": {
            "catcher_id": "3ea7bfcd7786a0c3abe5c7424ebcec6f",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b",
            "honeypot": "3a5d5dd41fa8346a873da6ad75b4e59a"
        }
    },

    consultation: {   
        "feedback_active": false, 
        "start_datetime": "",
        "end_datetime": "",
        "closed_message": "This consultation is closed and is no longer accepting feedback.",
        
        // Consultation close countdown. If set to true, show countdown in site header
        "has_countdown": false,
        "countdown_end": "03/31/2022 23:59:59", // Date format MM/DD/YYYY HH:MM:SS

        "themes": [
            {
                "name": "Our proposals",
                "url": "section-1",
                "feedback_url": '',
                "icon": "design",
                "question": "Do you have any comments on the overall principles of the proposed development?",
                "key": "01-section"
            },
            {
                "name": "Improvements",
                "url": "section-2",
                "feedback_url": 'page-2/',
                "icon": "tick",
                "question": "We're looking at how best we can improve the local street scene. Do you have any further ideas on landscaping, greenery and improvements to pedestrian areas?",
                "key": "02-section"
            },
            {
                "name": "Affordable workspaces",
                "url": "section-3",
                "feedback_url": 'page-3/',
                "icon": "workplace",
                "question": "Are there any types of businesses that you would be keen to see use the affordable workspace that will be provided as part of the proposals?",
                "key": "03-section"
            },
            {
                "name": "Other comments",
                "url": "section-4",
                "feedback_url": 'page-4/',
                "icon": "question",
                "question": "Do you have any other comments?",
                "key": "04-section"
            },
            {
                "name": "About you",
                "url": "section-5",
                "feedback_url": 'page-5/',
                "icon": "person",
                "question": "Are you a local resident or business owner?",
                "question-2": "",
                "question-3": "",
                "question-4": "",
                "question-5": "",

                "key": "05-section"
            }
        ]
    },

    downloads: [
        {
            "title": "Download 1",
            "url": "#"
        },
        {
            "title": "Download 2",
            "url": "#"
        },
        {
            "title": "Download 3",
            "url": "#"
        }
    ],
    
    faqs: [
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
    ],

    hasMap: false,

    // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? '[STAGING LINK]' : '[PROD LINK]',

    // Bugsnag API Key
    //bugsnagApiKey: '6f96fe3984a9d059b50f39cf58c083e4',

    // Marker.io Key - replace this default key
    marker_io: '6735e410d8addb5896f59513'
};